import React from 'react'
import PropTypes from 'prop-types'
import { FroalaTextEditor } from 'components/UIElements'
import { stripHtmlTags } from 'utils/misc'

/**
 * Admin preview for horizontal_select_one: left anchor | numeric boxes | right anchor.
 * When scoring is enabled, green score values render below each option (same placement as the builder).
 */
const HorizontalSelectOneView = ({ item }) => {
  const left = item.attributes?.left_anchor ?? ''
  const right = item.attributes?.right_anchor ?? ''
  const { choices, choices_order: order } = item
  const hasLeftAnchor = !!stripHtmlTags(left).trim()
  const hasRightAnchor = !!stripHtmlTags(right).trim()
  const hasScoring =
    !!item.attributes?.hasScoring ||
    (order || []).some(choiceId => {
      const scoreValue = choices?.[choiceId]?.score_value
      return scoreValue !== undefined && scoreValue !== null && scoreValue !== ''
    })

  return (
    <div className={`horizontal-select-one-preview${hasScoring ? ' has-scoring' : ''}`}>
      {hasLeftAnchor && (
        <div className='horizontal-select-one-preview__anchor horizontal-select-one-preview__anchor--left'>
          <FroalaTextEditor value={left} readOnly={true} showToolbar={false} />
        </div>
      )}
      <div className='horizontal-select-one-preview__boxes'>
        {(order || []).map(choiceId => (
          <div key={choiceId} className='horizontal-select-one-preview__choice'>
            <div className='horizontal-select-one-preview__box'>
              {choices[choiceId]?.value ?? ''}
            </div>
            {hasScoring && (
              <span className='horizontal-select-one-preview__score'>
                {choices[choiceId]?.score_value ?? ''}
              </span>
            )}
          </div>
        ))}
      </div>
      {hasRightAnchor && (
        <div className='horizontal-select-one-preview__anchor horizontal-select-one-preview__anchor--right'>
          <FroalaTextEditor value={right} readOnly={true} showToolbar={false} />
        </div>
      )}
    </div>
  )
}

HorizontalSelectOneView.propTypes = {
  item: PropTypes.object.isRequired,
}

export default HorizontalSelectOneView
